import { api } from "../config/baseApi";
import { postRequest } from "../utils/axios";

type DataFromFetchType = {
  success: boolean;
  message: string;
  status: number;
  content: any;
  error?: { message?: string };
};

// const timeoutDuration = 5000; // Timeout duration in milliseconds

// const createFetchRequest = (
//   url: string,
//   method: string,
//   token?: string,
//   body?: any
// ) => {
//   const controller = new AbortController();
//   const { signal } = controller;

//   const timeoutId = setTimeout(() => {
//     controller.abort();
//   }, timeoutDuration);

//   const headers: HeadersInit = {
//     Accept: "application/json",
//     "Content-Type": "multipart/form-data",
//   };

//   if (token) {
//     headers["Authorization"] = `Bearer ${token}`;
//   }

//   const request: RequestInit = {
//     method,
//     headers,
//     signal,
//   };

//   if (body) {
//     request.body = JSON.stringify(body);
//   }

//   return { url, request, timeoutId };
// };

// const handleFetchError = (error: any): DataFromFetchType => {
//   clearTimeout(error.timeoutId);

//   if (error.name === "AbortError") {
//     return {
//       success: false,
//       message: "Request timed out",
//       status: 500,
//       content: {},
//     };
//   } else {
//     console.log(error);
//     return {
//       success: false,
//       message: "Problème de connexion !",
//       status: 500,
//       content: {},
//     };
//   }
// };

// export const editProfilePhoto = (
//   data: any,
//   userId: any
// ): Promise<DataFromFetchType> => {
//   const { url, request, timeoutId } = createFetchRequest(
//     `${api}/user/${userId}/upload-profile-image`,
//     "POST",
//     undefined,
//     data
//   );

//   return fetch(url, request)
//     .then((response: Response) => {
//       clearTimeout(timeoutId);
//       return response.json();
//     })
//     .catch(handleFetchError);
// };

type DataFromAxiosType = {
  data: {
    success: boolean;
    message: string;
    status: number;
    content: Record<string, any>;
  };
};

async function editProfilePhoto(bodyData, userId): Promise<DataFromAxiosType> {
  try {
    const { data }: DataFromAxiosType = await postRequest(
      `${api}/user/${userId}/upload-profile-image`,
      bodyData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (!data.success) {
      throw new Error(data?.message);
    }

    return {
      data,
    };
  } catch (error: any) {
    const returnedData: DataFromAxiosType = {
      data: {
        success: false,
        message: error?.message ?? "",
        status: error?.response?.status ?? 500,
        content: [],
      },
    };
    return returnedData;
  }
}

export default editProfilePhoto;
